module.exports = __webpack_public_path__ + "img/macdaddy-office.55f94049.jpg";